<div>
  <div *ngIf="operatingFlightNumber"
       class="d-flex justify-content-between gap-20"
       [class.mb-2]="aircraftCode">
    <span>{{ 'OPERATED_BY_POPOVER.OPERATING_FLIGHT_NUMBER' | translate }}</span>
    <span class="black-color">{{operatingFlightNumber}}</span>
  </div>
  <div *ngIf="aircraftCode"
       class="d-flex justify-content-between gap-20">
    <span>{{ 'OPERATED_BY_POPOVER.AIRCRAFT' | translate }}</span>
    <span class="black-color">{{aircraftCode}}</span>
  </div>
</div>
